export const state = {
  token: sessionStorage['site_current_token'] ? sessionStorage['site_current_token'] : '', //token
  userid: localStorage['site_current_userid'] ? localStorage['site_current_userid'] : 0, //当前account_id
  app_id: 'wx4d486fa83c992b4d', //当前 app_id
  retry_count: 0, //登录重试次数,防止同一页面中多个ajax同时触发登录操作
  after_login_go: localStorage['site_current_login_go'] ? localStorage['site_current_login_go'] : '', //登录后跳转
  vehicleState: localStorage['vehicleState'] ? localStorage['vehicleState'] : '01',
  wx_info: {
    nickname: localStorage['wx_nickname'] ? localStorage['wx_nickname'] : '',
    username: localStorage['wx_username'] ? localStorage['wx_username'] : '',
    mobile: localStorage['wx_mobile'] ? localStorage['wx_mobile'] : '',
    headimgurl: localStorage['wx_headimgurl'] ? localStorage['wx_headimgurl'] : '',
    sex: '',
    openid: localStorage['wx_openid'] ? localStorage['wx_openid'] : '',
  },
  yhcgbazt: localStorage['yhcgbazt'] ? localStorage['yhcgbazt'] : '0',
  yhctbazt: localStorage['yhctbazt'] ? localStorage['yhctbazt'] : '0',
  yhjsybazt: localStorage['yhjsybazt'] ? localStorage['yhjsybazt'] : '0',
  yhyyybazt: localStorage['yhyyybazt'] ? localStorage['yhyyybazt'] : '0',
  slot: localStorage['slot'] ? localStorage['slot'] : 0,
  showMineTab: localStorage['showMineTab'] ? localStorage['showMineTab'] === 'true' : true,
  aiChatVehicleBound: localStorage['aiChatVehicleBound'] ? localStorage['aiChatVehicleBound'] === 'true' : false,
  thyySelectedContent: {},
  isLoading: false,
  isFirstTime: false
};
